/* eslint-disable jsx-a11y/label-has-for, css-modules/no-unused-class */
import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';

import s from './Checkbox.scss';

const Checkbox = ({
  name,
  label,
  checked,
  disabled,
  alternative,
  required,
  onChange,
  hasError,
  showLabel,
  innerRef,
  ...props
}) => {
  const classes = cx(
    s.root,
    disabled && s['root--disabled'],
    alternative && s['root--alternative'],
    hasError && s.hasError,
  );

  const inputRef = useRef();
  const labelClass = cx(showLabel ? s.label : 'visually-hidden');

  return (
    <label className={classes} {...props}>
      <input
        name={name}
        className={s.root__input}
        type="checkbox"
        checked={checked}
        disabled={disabled}
        required={required}
        onChange={onChange}
        ref={innerRef || inputRef}
      />
      <span className={labelClass}>{label}</span>
      <span
        className={cx(
          s.root__checkmark,
          alternative && s['root__checkmark--alternative'],
        )}
      />
      {hasError && <span className={s.error}>{hasError.message}</span>}
    </label>
  );
};

Checkbox.propTypes = {
  name: PropTypes.string,
  required: PropTypes.bool,
  label: PropTypes.node,
  disabled: PropTypes.bool,
  checked: PropTypes.bool,
  alternative: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  hasError: PropTypes.bool,
  showLabel: PropTypes.bool,
  innerRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape()]),
};

Checkbox.defaultProps = {
  name: 'checkbox',
  label: undefined,
  checked: false,
  disabled: false,
  required: false,
  alternative: false,
  hasError: false,
  showLabel: false,
  innerRef: null,
};

export default withStyles(s)(Checkbox);
